import React from 'react';
import UserActions from '../../Actions/UserAction';
import Loader from './Loader';
import { generatePath } from 'react-router-dom';


const CustomActionsWrapper = (props) => {

    //state
    const [user, setUser] = React.useState(null);

    React.useEffect(() => {
        const init = async () => {
            let userData = null;
            try {
                userData = await UserActions.getCurrentUser(false);
            } catch (error) { }

            if (userData) {
                setUser(userData);
            } else {
                setUser(false);
            }
        }
        if (user == null) {
            init();
        }
    }, []);


    if (user == null) {
        return <Loader />
    }

    if (user === false) {
        return (
            <>
                {props.children}
            </>
        );
    }
    
    return (
        <>
            {props.children}
            <div style={{ position: 'absolute', top: '300px', left: '10px', zIndex: 1000 }}>
                <div
                    className={'standard-padding-2 vertical-padding-2 touchable'}
                    style={{ backgroundColor: '#fdb019', borderRadius: 100 }}
                    onClick={() => {
                        if (window.location.pathname === generatePath('/actions_home')) {
                            window.location.href = generatePath('/');
                        } else {
                            window.location.href = generatePath('/actions_home');
                        }
                    }}
                >
                    <i className={'la la-bell'} style={{ color: '#fff', fontSize: 22, marginRight: 10, marginTop: 2 }} />
                    {window.location.pathname === generatePath('/actions_home') ?
                        <i className={'la la-angle-left'} style={{ color: '#fff', fontSize: 22, marginTop: 2 }} /> :
                        <i className={'la la-angle-right'} style={{ color: '#fff', fontSize: 22, marginTop: 2 }} />
                    }
                </div>
            </div>
        </>
    );
};

export default (props) => {
    return <CustomActionsWrapper {...props} />;
};